/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_Ask_Discord_DescriptionInputs */



/**
* | output |
* | --- |
* | "Chat, report bugs, or share ideas" |
*
* @param {Layout_Header_Ask_Discord_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_ask_discord_description = /** @type {((inputs?: Layout_Header_Ask_Discord_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Ask_Discord_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Chatten, Fehler melden oder Ideen teilen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Discutez, signalez des bugs ou partagez des idées")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("聊天、报告问题或分享想法")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("聊天、回報問題或分享點子")
	if (locale === "ko") return /** @type {LocalizedString} */ ("대화하고, 버그를 알리고, 아이디어를 나누세요")
	return /** @type {LocalizedString} */ ("Chat, report bugs, or share ideas")
});